import { CSSProperties, FC, ReactNode } from "react";

type widthRestrictorType = {
  children: ReactNode;
  maxWidth?: string;
  backgroundColor?: string;
  padding?: string;
  style?: CSSProperties;
};

const WidthRestrictor: FC<widthRestrictorType> = ({
  children,
  maxWidth = "1440px",
  backgroundColor,
  padding,
  style,
}) => {
  return (
    <div data-testid="fullWidth" style={{ backgroundColor, padding }}>
      <div
        data-testid="restrictedWidth"
        style={{ ...style, maxWidth, margin: "0 auto" }}
      >
        {children}
      </div>
    </div>
  );
};

export default WidthRestrictor;
